import React from "react";
import { IconStar } from "@tabler/icons-react";

const FavoriteStar = ({ isFavorite, style }) => {
	return (
		<div
			className={isFavorite ? "IsFavorite" : "IsNotFavorite"}
			style={{
				position: "relative",
				width: "1em",
				height: "1em",
				...style,
			}}
		>
			<IconStar
				fill={isFavorite ? "var(--lw-gold)" : "none"}
				style={{ marginTop: -2 }}
				size={18}
			/>
		</div>
	);
};

export default FavoriteStar;
